module.exports = __webpack_public_path__ + "media/images/sample/thumb-posts-49e42e5d7db5ad09332e511aa54def3f.png";